import Svg from 'components/svg';

const Cross = Svg((
  <path d="M6.99998 1.00002L1 7M0.999975 1L6.99995 6.99998" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
), { viewBox: '0 0 8 8', fill: 'none' });

Cross.displayName = 'Close';

export default Cross;
